/* eslint-disable strict */
(function () {
    'use strict';

    angular.module('legitimationUpload')

        .directive('loadingspinner', function () {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    scope.$on('bcstLoadingSpinner_show', function () {
                        return element.show();
                    });
                    scope.$on('bcstLoadingSpinner_hide', function () {
                        return element.hide();
                    });
                }
            };
        })

        .directive('modTooltip', function () {
            return {
                restrict: 'A',
                link: function (scope, elem) {
                    vf.tooltip.init($(elem));
                }
            };
        })

        .directive('errorBox', function ErrorBox() {
            return {
                restrict: 'E',
                scope: {},
                templateUrl: '/simplicity/ajax/html/legitimation-upload/snippets/data_error.html',
                transclude: true,
                controller: ['$scope', function($scope) {
                    this.$onInit = function() {
                        $scope.errors = [];
                        this.addError = function(error) {
                            $scope.errors.push(error);
                        };

                        this.removeError = function(error) {
                            var idx = $scope.errors.indexOf(error);
                            if (-1 < idx) {
                                $scope.errors.splice(idx, 1);
                            }
                        };
                    };
                }]

            };
        })

        .directive('errorItem', function ErrorItem() {
            return {
                require: '^^errorBox',
                restrict: 'E',
                scope: {
                    title: '@',
                    inputInvalid: '='
                },
                transclude: true,
                template: '',
                link: function(scope, element, attrs, errorsCtrl) {
                    scope.$watch('inputInvalid', function (v) {
                        if (v) {
                            errorsCtrl.addError(scope.title);
                        } else {
                            errorsCtrl.removeError(scope.title);
                        }
                    });
                }
            };
        });

}());
